import React from 'react';
import { Button } from '@routific/hive';
import { useTranslation } from 'react-i18next';

interface Props {
  onReoptimize: () => void;
  onBestInsert?: () => void;
  onCancel: () => void;
  reoptimizeButton?: boolean;
}

const ReoptimizeConfirmModalFooter: React.FC<Props> = ({
  onReoptimize,
  onBestInsert,
  onCancel,
  reoptimizeButton = false,
}) => {
  const { t } = useTranslation('components');

  const buttons = [];

  if (reoptimizeButton) {
    buttons.push(
      <Button key="cancel" onClick={onCancel} data-cy="reoptimize-confirm-cancel" data-testid="reoptimize-confirm-cancel">
        {t('reoptimizeRouteConfirmModal.cancel')}
      </Button>,
    );
  } else {
    buttons.push(
      <Button key="best-insert" onClick={onBestInsert} data-cy="reoptimize-confirm-best-insert" data-testid="reoptimize-confirm-best-insert">
        {t('reoptimizeRouteConfirmModal.bestInsert')}
      </Button>,
    );
  }

  buttons.push(
    <Button key="reoptimize" type="primary" onClick={onReoptimize} data-cy="confirm-reoptimize-button" data-testid={reoptimizeButton ?
      'confirm-reoptimize-button' : 'confirm-reoptimize-insert-button'}>
      {t('reoptimizeRouteConfirmModal.reoptimize')}
    </Button>,
  );

  return <>{buttons}</>;
};

export default ReoptimizeConfirmModalFooter;
